module.exports = __webpack_public_path__ + "img/class3.01df63af.png";